import React from "react";

import {
  Check as CheckIcon,
  CloseRounded as CloseRoundedIcon,
} from "@mui/icons-material";
import {
  Box,
  CircularProgress,
  Modal,
  Typography,
  Button,
} from "@mui/material";
import { makeStyles } from "tss-react/mui";

import { AppointmentStatusKind } from "@/gql/graphql";
import { colors } from "@/theme/overrides/colors";

type ModalProps = {
  open: boolean;
  onClose: () => void;
  startDate?: string | null | undefined;
  startTime?: string | null | undefined;
  endTime?: string | null | undefined;
  fullName?: string | null | undefined;
  status?: string | null | undefined;
};
const useStyles = makeStyles()((theme) => ({
  root: {
    overflowY: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(4),
  },
  modalBody: {
    display: "flex",
    flexDirection: "column",
    margin: theme.spacing(24, 24),
    backgroundColor: colors.white,
    overflowY: "auto",
    width: "470px",
  },
  content: {
    padding: "40px",
  },
  header: {
    fontSize: "20px",
    fontWeight: 700,
    marginBottom: "12px",
  },
  message: {
    fontSize: "16px",
    fontWeight: 600,
    paddingBottom: "20px",
    marginBottom: "20px",
    borderBottom: "1px solid #DEE6F0",
  },
  iconContainer: {
    height: "66px",
    width: "66px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    marginBottom: "20px",
  },
  icon: {
    color: colors.white,
    fontSize: "50px",
  },
  schedule: {
    fontSize: "16px",
    fontWeight: 700,
    marginBottom: "10px",
  },
  fullname: {
    fontSize: "16px",
    color: "#0B1B26",
    marginBottom: "10px",
    fontWeight: 700,
  },
}));

const AppointmentConfirmationModal: React.FC<ModalProps> = ({
  open,
  onClose,
  startDate,
  startTime,
  endTime,
  fullName,
  status,
}) => {
  const { classes } = useStyles();
  return (
    <Modal open={open} onClose={onClose} className={classes.root}>
      <Box className={classes.modalBody}>
        <div>
          <Box className={classes.content}>
            <Box display="flex" justifyContent="center" alignItems="center">
              <Box
                className={classes.iconContainer}
                style={{
                  backgroundColor: status == "upcoming" ? "#2D87BB" : "#FF6262",
                }}
              >
                {status?.toUpperCase() === AppointmentStatusKind.Upcoming ? (
                  <CheckIcon className={classes.icon} />
                ) : (
                  <CloseRoundedIcon className={classes.icon} />
                )}
              </Box>
            </Box>
            <Box display="flex" justifyContent="center" alignItems="center">
              <Typography className={classes.message}>
                Your appointment has been
                {status == "upcoming" ? " successfully booked" : " cancelled"}.
              </Typography>
            </Box>

            <Box display="flex" justifyContent="center" alignItems="center">
              <Typography className={classes.fullname}>{fullName}</Typography>
            </Box>
            <Box display="flex" justifyContent="center" alignItems="center">
              <Typography className={classes.schedule}>
                {startDate ? (
                  `${startDate ?? "N/A"} | ${startTime ?? "N/A"} - ${
                    endTime ?? "N/A"
                  }`
                ) : (
                  <CircularProgress />
                )}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="center" alignItems="center">
              <Button color="primary" type="submit" onClick={onClose}>
                Done
              </Button>
            </Box>
          </Box>
        </div>
      </Box>
    </Modal>
  );
};

export default AppointmentConfirmationModal;
